import "./home.css";

import React from "react";

import { HOME, SECTIONS } from "../../data/content";
import { PRODUCT_CATEGORIES } from "../../data/products";
import PageMeta from "../general/PageMeta";
import ProductModal from "./ProductModal";

const Home = () => {
  const [openCategory, setOpenCategory] = React.useState(null);

  return (
    <React.Fragment>
      <PageMeta title={HOME.metaTitle} />

      {/* Hero - the pecan page background shows through, with the header on top */}
      <section
        className={"hero"}
        style={{ "--bg-image": "url(/images/hero-pecans.jpg)" }}
      >
        <div className={"hero-inner"}>
          <img
            className={"hero-logo"}
            src={"/images/logo-white.png"}
            alt={""}
            width={"600"}
            height={"520"}
          />
          <h1 className={"hero-text"}>{HOME.hero}</h1>
        </div>
      </section>

      <span className={"orange-rule"} />

      <section
        id={SECTIONS.ABOUT}
        className={"about"}
      >
        <div className={"about-inner container"}>
          <div className={"about-text"}>
            <h2 className={"script-title"}>{HOME.about.title}</h2>
            {HOME.about.paragraphs.map((p) => (
              <p key={p.slice(0, 20)}>{p}</p>
            ))}
          </div>
          <figure className={"about-map"}>
            <img
              src={"/images/map.png"}
              alt={HOME.about.mapAlt}
              width={"1500"}
              height={"999"}
              loading={"lazy"}
            />
            <figcaption>
              <span className={"legend export"}>{HOME.about.exportLabel}</span>
              <span className={"legend import"}>{HOME.about.importLabel}</span>
            </figcaption>
          </figure>
        </div>
      </section>

      <span className={"orange-rule"} />

      <section
        className={"values"}
        aria-label={"Our mission and values"}
      >
        <div className={"values-inner container"}>
          {HOME.values.map((v) => (
            <div
              key={v.title}
              className={"value"}
            >
              <h3>{v.title}</h3>
              <p>{v.text}</p>
            </div>
          ))}
        </div>
      </section>

      <span className={"orange-rule"} />

      <section
        id={SECTIONS.SERVICES}
        className={"services"}
        aria-label={"Services"}
        style={{ "--bg-image": "url(/images/brazil-nuts.jpg)" }}
      >
        <div className={"services-inner container"}>
          {HOME.services.map((s) => (
            <div
              key={s.title}
              className={"service"}
            >
              <span
                className={"service-icon"}
                style={{ "--icon": `url(${s.icon})` }}
                aria-hidden={"true"}
              />
              <h3>{s.title}</h3>
              <p>{s.text}</p>
            </div>
          ))}
        </div>
      </section>

      <span className={"orange-rule"} />

      <section
        id={SECTIONS.RETAILERS}
        className={"retailers"}
      >
        <div className={"container"}>
          <h2 className={"script-title"}>{HOME.retailers.title}</h2>
          <ul className={"retailer-logos"}>
            {HOME.retailers.logos.map((r) => (
              <li key={r.name}>
                <img
                  src={r.image}
                  alt={r.name}
                  loading={"lazy"}
                />
              </li>
            ))}
          </ul>
        </div>
      </section>

      <span className={"orange-rule"} />

      <section
        className={"products-process"}
        aria-label={"Our products and process"}
      >
        <div className={"pp-columns"}>
          {HOME.productsAndProcess.map((item) => (
            <div
              key={item.title}
              className={"pp-column"}
              style={{ "--bg-image": `url(${item.image})` }}
            >
              <div className={"pp-band"}>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </div>
            </div>
          ))}
        </div>
        <div className={"haccp"}>
          <div className={"container"}>
            <p className={"haccp-heading"}>{HOME.haccp.heading}</p>
            <p>{HOME.haccp.text}</p>
          </div>
        </div>
      </section>

      <span className={"orange-rule"} />

      <section
        id={SECTIONS.PRODUCTS}
        className={"products"}
      >
        <div className={"container"}>
          <h2 className={"script-title"}>{HOME.productsTitle}</h2>
          <ul className={"category-grid"}>
            {PRODUCT_CATEGORIES.map((cat) => (
              <li key={cat.slug}>
                <button
                  type={"button"}
                  className={"category-tile"}
                  onClick={() => setOpenCategory(cat)}
                  aria-haspopup={"dialog"}
                >
                  <span className={"category-circle"}>
                    <img
                      src={cat.image}
                      alt={""}
                      width={"360"}
                      height={"360"}
                      loading={"lazy"}
                    />
                  </span>
                  <span className={"category-name"}>{cat.title}</span>
                </button>
              </li>
            ))}
          </ul>
        </div>
      </section>

      {openCategory ? (
        <ProductModal
          category={openCategory}
          onClose={() => setOpenCategory(null)}
        />
      ) : null}
    </React.Fragment>
  );
};

export default Home;
